<!--Temporary hide for now - https://app.clickup.com/t/8692yrn2t-->
<ng-container *ngIf="isVisible && false">
  <div class="fill-card"
       [class.tablet]="deviceService.isTablet()"
       [class.mobile]="deviceService.isMobile()">
    <div class="profile-card">
      <div class="icon"></div>
      <ng-container *ngTemplateOutlet="stepsBlock"></ng-container>
    </div>
  </div>
</ng-container>

<ng-template #stepsBlock>
  <div class="text" *ngIf="!checkedSteps; else showProgress">
    <p class="title">{{ 'onboarding.steps-widget.title' | translate }}</p>
    <p class="description">
      {{ 'onboarding.steps-widget.description' | translate }}
      <!--Hide for now till info popup will be ready-->
      <!--<a href="#"> {{ 'onboarding.steps-widget.more-details' | translate }}</a>-->
    </p>
  </div>
  <ng-template #showProgress>
    <div class="text">
      <p class="title">{{ 'onboarding.steps-widget.title' | translate }}</p>
      <div class="progressbar" [class.mobile]="deviceService.isMobile()">
          <span>{{ 'onboarding.steps-widget.steps-checked' | translate : {
            'checked-steps': checkedSteps,
            'all_steps': maxSteps
          } }}</span>
        <app-onboarding-progressbar
          [max]="maxSteps" [value]="checkedSteps"
          [rounded]="true">
        </app-onboarding-progressbar>
        <div class="action" *ngIf="deviceService.isMobile()">
          <on-ui-button
            class="third"
            (click)="navigate()"
            [label]="(!checkedSteps ? 'onboarding.steps-widget.button-1' : 'onboarding.steps-widget.button-2') | translate">
          </on-ui-button>
        </div>
        <span *ngIf="!deviceService.isMobile()">{{ 'onboarding.steps-widget.percent-checked' | translate : {'percent': percent} }}</span>
      </div>
    </div>
  </ng-template>
  <div class="action" *ngIf="!deviceService.isMobile()">
    <on-ui-button
      class="third"
      (click)="navigate()"
      [label]="(!checkedSteps ? 'onboarding.steps-widget.button-1' : 'onboarding.steps-widget.button-2') | translate">
    </on-ui-button>
  </div>
</ng-template>
